<template>
  <div class="picklist-detail">
    <template v-if="!store.error && !store.loading">
      <picklist-detail :data="store.data" ref="picklistDetail" v-model="picklistPicker.selectedPosition" />
    </template>
    <template v-if="store.error">
      <error :module="store.$id" />
    </template>
    <template v-if="store.loading">
      <loading />
    </template>
  </div>
</template>

<script setup lang="ts">
import Loading from '@/components/Loading.vue';
import ErrorComp from '@/components/Error.vue';
import PicklistDetail from '@/components/Picklist/PicklistDetail.vue';
import pinia from '@/plugins/pinia';
import {doConfirm} from '@/util';
import Picklist, {ApiPicklistState, ApiPicklistType} from '@/model/Picklist';
import useDetailPicklist from '@/store/detailPicklist';
import {useStorage} from '@/composables/storage';
import {onBeforeRouteLeave, useRoute} from 'vue-router';
import {usePicklistPickerStore} from '@/store/picklistPickerV2';
import moment from 'moment/moment';

const picklistPicker = usePicklistPickerStore(pinia);
const store = useDetailPicklist();
const route = useRoute();
useStorage(
    store,
    (picklist) => picklist ? `Pickliste ${picklist?.Picklistnr}` : 'Pickliste',
  route.params.id !== '-1' ? (route) => ({Picklistnr: route.params.id as string}) : null,
  async () => {
    try {
      if (route.params.id === '-1') {
        const picklist = Picklist.fromApi({
          Art: ApiPicklistType.Order,
          Picklistnr: '-1',
          BestellNr: null,
          KundenNr: Number(route.query.kunde as string),
          Erstelltam: moment().format('YYYY-MM-DD'),
          Erstelltdurch: '',
          Status: ApiPicklistState.Todo,
          Kmsdatum: route.query.lieferdatum as string,
          Kmsuhrzeit: '',
          Kmsprioritaet: '',
          Kmsam: route.query.lieferdatum as string,
          Kmsdurch: '',
          Kmsbediener: null,
          Tour: [],
          Auftraege: [],
          InterneAuftraege: [],
        });
        await picklistPicker.edit(picklist);
      } else {
        await picklistPicker.edit();
      }
    } catch (err) {
      console.error(err);
    }
  },
);

onBeforeRouteLeave(async (_to, _from, next) => {
  if (picklistPicker.picklist?.Status === ApiPicklistState.Active) {
    if (picklistPicker.addedItems > 0 && await doConfirm('Aktuelle Pickliste parken?', 'Parken?')) {
      await picklistPicker.park();
    } else if (await doConfirm('Aktuelle Pickliste verwerfen?', 'Verwerfen?')) {
      await picklistPicker.cancel();
    } else {
      next(false);
      return;
    }
  }

  if (picklistPicker.picklist?.Picklistnr === '-1' && picklistPicker.picklist?.Status === ApiPicklistState.Todo) {
    if (await doConfirm('Soll die Anlage der Pickliste wirklich abgebrochen werden?', 'Wirklich abbrechen?')) {
      next();
      return;
    } else {
      next(false);
      return;
    }
  }

  next();
});

defineExpose({
  Loading,
  Error: ErrorComp,
  PicklistDetail,
  store,
  picklistPicker,
});
</script>

<style lang="scss" scoped>
  .picklist-detail {
    padding-bottom: 100px;
  }
  .fixed-bottom {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid #ccc;
    background-color: #f1f1f1;
    text-align: center;
    display: flex;
    justify-content: center;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
  }
  .v-card__actions:empty {
    display: none;
  }
  .picklist-detail-status {
    font-size: 14px;
  }
  .position-header {
    display: flex;
    justify-content: space-between;
    span {
      font-size: 12px;
    }
  }
  //Temp
  .grey.lighten-4 {
    color: #415564 !important;
  }
</style>
